import React, { Component } from 'react'
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import Subadminsidebar from "../SubAdminSideBar"
// import SubadminManageUser from "../SubAdminManageUser"
import SubadminManageUser from "../SubAdminManageUser2"
import queryString from "query-string";

const SubAdminSideBarPage = (props) => {
  if (props.location.search) {
    let values = queryString.parse(props.location.search);
    sessionStorage.setItem("token", values.token);
  }
    return (
      <Subadminsidebar>
        <SubadminManageUser />
      </Subadminsidebar>
    );
  };
  export default NetworkDetector(SubAdminSideBarPage);
